import { BigMagnifyingIcon } from "../../../../ui/icons/BigMagnifyingIcon";
import { MenuBox } from "../../components/menuBox";

export function InspectionVisitBlocksEdit() {
    return (
        <div style={{ padding: '24px' }}>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                <MenuBox
                    title='Cartella Aziendale'
                    size="sm"
                    color="green"
                    icon={<BigMagnifyingIcon size={20} />}
                />

                <MenuBox
                    title='Notifiche'
                    size="sm"
                    color="green"
                    icon={<BigMagnifyingIcon size={20} />}
                />

                <MenuBox
                    title='Elenco Controlli'
                    size="sm"
                    color="green"
                    icon={<BigMagnifyingIcon size={20} />}
                />

                <MenuBox
                    title='Certificati'
                    size="sm"
                    color="green"
                    icon={<BigMagnifyingIcon size={20} />}
                />

                <MenuBox
                    title='Provvedimenti'
                    size="sm"
                    color="green"
                    icon={<BigMagnifyingIcon size={20} />}
                />

                <MenuBox
                    title='RID'
                    subtitle="Richiesta Integrazione Documenti"
                    size="sm"
                    color="green"
                    icon={<BigMagnifyingIcon size={20} />}
                />

                <MenuBox
                    title='Registri Aziendali'
                    size="sm"
                    color="green"
                    icon={<BigMagnifyingIcon size={20} />}
                />

                <MenuBox
                    title='Scheda Prodotto'
                    size="sm"
                    color="green"
                    icon={<BigMagnifyingIcon size={20} />}
                />

                <MenuBox
                    title='Transazioni'
                    size="sm"
                    color="green"
                    icon={<BigMagnifyingIcon size={20} />}
                />

                <MenuBox
                    title='Liberatoria'
                    size="sm"
                    color="green"
                    icon={<BigMagnifyingIcon size={20} />}
                />

                <MenuBox
                    title='Invio Calendario Produzioni'
                    size="sm"
                    color="green"
                    icon={<BigMagnifyingIcon size={20} />}
                />

                <MenuBox
                    title='Documenti'
                    size="sm"
                    color="green"
                    icon={<BigMagnifyingIcon size={20} />}
                />

                <MenuBox
                    title='xxxx'
                    size="sm"
                    color="green"
                    icon={<BigMagnifyingIcon size={20} />}
                />

                <MenuBox
                    title='xxx'
                    size="sm"
                    color="green"
                    icon={<BigMagnifyingIcon size={20} />}
                />
            </div>
        </div>
    )
}